import React from 'react';
import Type from 'prop-types';
import { Box, Typography, Avatar } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { getInitials } from 'utils/string';
import useStyles from './HeaderAccount.styles';

const HeaderAccount = props => {
  const { account, loading } = props;
  const classes = useStyles();

  const renderAvatar = () => {
    const initials = getInitials(account.fullName);

    return (
      <Avatar src={account.avatar} alt={account.fullName} className={classes.accountAvatar}>
        {initials}
      </Avatar>
    );
  };

  return (
    <Box className={classes.account} py={3} px={2}>
      {loading ? <Skeleton variant="circle" width={48} height={48} /> : renderAvatar()}
      <div className={classes.accountContent}>
        {loading ? (
          <Skeleton height={16} width="80%" style={{ marginBottom: 8 }} />
        ) : (
          <Typography className={classes.accountName} component="div" variant="body1">
            {account.fullName}
          </Typography>
        )}

        {loading ? (
          <Skeleton height={16} width="60%" />
        ) : (
          account.email && (
            <Typography component="div" variant="body1">
              {account.email}
            </Typography>
          )
        )}
      </div>
    </Box>
  );
};

HeaderAccount.propTypes = {
  account: Type.shape({
    fullName: Type.string.isRequired,
    avatar: Type.string,
    email: Type.string,
  }),
  loading: Type.bool,
};

HeaderAccount.defaultProps = {
  account: undefined,
  loading: false,
};

export default HeaderAccount;
